import { Outlet } from "react-router-dom";
import { formValueSelector } from "redux-form";

import { LayoutGenericForm } from "@js/apps/common/components";

import { ONBOARDING_FORM_ID } from "../../constants";
import { useOnboardingForm } from "../../hooks/onboarding-form";

export const OnboardingFormWrapper = () => {
  const { formProps } = useOnboardingForm();

  return (
    <LayoutGenericForm form={ONBOARDING_FORM_ID} {...formProps}>
      <Outlet />
    </LayoutGenericForm>
  );
};

export const onboardingFormValueSelector =
  formValueSelector(ONBOARDING_FORM_ID);
